@let form = this.form();
<app-page size="medium">
    <app-breadcrumbs [crumbs]="crumbs"></app-breadcrumbs>

    @if (form) {
        @if (!canSaveLeave) {
            <app-info-banner title="Dit verlof kan niet meer worden aangepast." tone="info">
                <a [routerLink]="['/', Routenames.leave]" actions mat-stroked-button>Naar overzicht</a>
            </app-info-banner>
        }

        <form [formGroup]="form" class="leave-form" id="user-form">
            <div class="main">
                <app-section icon="bars" layout="stacked" title="Soort verlof">
                    <div aria-label="Soort verlof" class="type-tiles" role="radiogroup">
                        @for (type of leaveTypes(); track type.key) {
                            @let style = leaveTypeStyle(type.key);
                            @let active = form.controls.leave_type.value === type.key;
                            <button (click)="pickLeaveType(type.key)"
                                    [attr.aria-checked]="active"
                                    [class.active]="active"
                                    [disabled]="form.controls.leave_type.disabled"
                                    [matTooltip]="type.description"
                                    class="type-tile"
                                    role="radio"
                                    type="button">
                                <app-icon-tile [icon]="style.icon" [style.background]="style.bg" [style.color]="style.fg"></app-icon-tile>
                                <span>{{ type.name }}</span>
                            </button>
                        }
                    </div>
                    @if (!form.controls.leave_type.value && (form.dirty || form.controls.leave_type.touched)) {
                        <span class="ui-help d-block mt-3">Kies een verlofsoort om op te kunnen slaan.</span>
                    }
                </app-section>

                @if (Roles.Management | hasRole) {
                    <app-section icon="users" layout="stacked" title="Medewerkers">
                        <div class="people">
                            <mat-checkbox formControlName="common">Bedrijfsbreed</mat-checkbox>
                            @if (!form.getRawValue().common) {
                                <app-field>
                                    <ng-select
                                        [clearSearchOnAdd]="true"
                                        [clearable]="true"
                                        [closeOnSelect]="false"
                                        [items]="users()"
                                        [multiple]="true"
                                        aria-label="Medewerkers"
                                        bindLabel="name"
                                        bindValue="id"
                                        class="ng-select-fill"
                                        formControlName="users"
                                        placeholder="Medewerkers">
                                        <ng-template ng-notfound-tmp>
                                            @if (form.value.leave_type) {
                                                <div class="ng-option disabled">Geen medewerkers gevonden</div>
                                            } @else {
                                                <div class="ng-option disabled">Kies eerst een verlofsoort</div>
                                            }
                                        </ng-template>
                                    </ng-select>
                                </app-field>
                            }
                        </div>
                    </app-section>
                }

                <app-section icon="calendar" layout="stacked" title="Wanneer">
                    <div class="when">
                        @if (form.value.interval) {
                            <app-field class="when-date" label="Vanaf">
                                <app-datetime-input
                                    [matFormField]="true"
                                    [min]="minDate"
                                    formControlName="begindate"
                                    labelDate="Begindatum"
                                    labelTime="Begintijd"></app-datetime-input>
                                <mat-error [control]="form.controls.begindate"></mat-error>
                            </app-field>
                        } @else {
                            <app-field class="when-date" for="leave-date" label="Datum">
                                <mat-form-field>
                                    <input
                                        (focus)="pickerStart.open()"
                                        [matDatepicker]="pickerStart"
                                        [min]="minDate"
                                        formControlName="begindate"
                                        id="leave-date"
                                        matInput placeholder="Datum">
                                    <mat-datepicker-toggle [for]="pickerStart" matSuffix></mat-datepicker-toggle>
                                    <mat-datepicker #pickerStart></mat-datepicker>
                                    <mat-error [control]="form.controls.begindate"></mat-error>
                                </mat-form-field>
                            </app-field>
                        }
                        <app-field label="Van">
                            <app-datetime-input
                                [hideDate]="true"
                                [matFormField]="true"
                                formControlName="begintime"
                                labelTime="Van"></app-datetime-input>
                            <mat-error [control]="form.controls.begintime"></mat-error>
                        </app-field>
                        <app-field label="Tot">
                            <app-datetime-input
                                [hideDate]="true"
                                [matFormField]="true"
                                formControlName="endtime"
                                labelTime="Tot"></app-datetime-input>
                            <mat-error [control]="form.controls.endtime"></mat-error>
                        </app-field>
                        <div class="duration">
                            <span class="duration-label">Duur per dag</span>
                            @let dayMinutes = this.dayMinutes();
                            @if (dayMinutes > 0) {
                                <span class="duration-value ui-mono">{{ dayMinutes | minutes }} uur</span>
                            } @else {
                                <span class="duration-value ui-mono ui-error">Ongeldig</span>
                            }
                        </div>
                    </div>

                    @if (canSaveLeave) {
                        <app-filter-chips (valueChange)="applyPreset($event)"
                                          [options]="presetOptions"
                                          [value]="activePreset(form.value.begintime, form.value.endtime)"
                                          class="presets"></app-filter-chips>
                    }

                    <div class="repeat">
                        <mat-checkbox class="repeat-toggle" formControlName="interval">Herhalend</mat-checkbox>
                        @if (form.value.interval) {
                            <div class="repeat-panel">
                                <app-field class="repeat-days" label="Op deze dagen">
                                    <div aria-label="Op deze dagen" class="weekdays" role="group">
                                        @for (day of weekdays; track day.key) {
                                            @let control = weekdayControl(day.key);
                                            <button (click)="toggleWeekday(day.key)"
                                                    [attr.aria-pressed]="!!control.value"
                                                    [class.active]="control.value"
                                                    [disabled]="control.disabled"
                                                    [title]="day.name"
                                                    type="button">{{ day.short }}</button>
                                        }
                                    </div>
                                </app-field>
                                <app-field for="interval_week" label="Elke">
                                    <mat-form-field>
                                        <input [attr.max]="52" [attr.min]="1" formControlName="interval_week" id="interval_week" matInput name="interval_week" type="number">
                                        <span class="ui-faint" matTextSuffix>{{ +form.getRawValue().interval_week === 1 ? 'week' : 'weken' }}</span>
                                        <mat-error [control]="form.controls.interval_week"></mat-error>
                                    </mat-form-field>
                                </app-field>
                                <app-field label="Tot en met">
                                    <app-datetime-input
                                        [matFormField]="true"
                                        [max]="maxDate"
                                        [min]="form.controls.begindate.value"
                                        formControlName="enddate"
                                        labelDate="Einddatum"
                                        labelTime="Eindtijd"></app-datetime-input>
                                    <mat-error [control]="form.controls.enddate"></mat-error>
                                </app-field>
                                <p class="ui-help repeat-help">
                                    Begint het verlof op de eerste dag later dan bij "Van", dan is op die dag de begintijd bij "Vanaf" leidend.
                                    Vice versa voor de eindtijd bij "Tot en met" op de laatste dag.
                                </p>
                            </div>
                        }
                    </div>
                </app-section>

                <app-section icon="comment" layout="stacked" title="Opmerkingen">
                    <!-- TODO(design): who sees "Opmerking" and "Publieke opmerking" is unconfirmed (README open point 8); hints are the design copy -->
                    <div class="comments">
                        <app-field for="leave-comment" label="Opmerking" optional>
                            <mat-form-field>
                                <input formControlName="comment" id="leave-comment" matInput placeholder="Bijv. verhuizen" type="text">
                                <mat-hint>Alleen zichtbaar voor jou en management.</mat-hint>
                                <mat-error [control]="form.controls.comment"></mat-error>
                            </mat-form-field>
                        </app-field>
                        <app-field for="leave-public-comment" label="Publieke opmerking" optional>
                            <mat-form-field>
                                <input formControlName="public_comment" id="leave-public-comment" matInput placeholder="Bijv. bereikbaar via telefoon" type="text">
                                <mat-hint>Zichtbaar voor collega's in de agenda.</mat-hint>
                                <mat-error [control]="form.controls.public_comment"></mat-error>
                            </mat-form-field>
                        </app-field>
                    </div>
                </app-section>
            </div>

            <app-section [flush]="true"
                         [subtitle]="previewRealisations()?.length === 1 ? '1 dag' : (previewRealisations()?.length ?? 0) + ' dagen'"
                         class="results"
                         layout="stacked"
                         title="Resulterende datums">
                <div class="results-list">
                    <app-data-list columns="28px minmax(0,1fr) auto" gap="10px">
                        @for (preview of previewRealisations(); track $index) {
                            <div app-data-row dense>
                                <span class="ui-meta">{{ preview.from | date:'EEEEEE' }}</span>
                                <span>{{ preview.from | date:'d MMM yyyy' }}</span>
                                <span class="ui-mono ui-muted results-times">{{ preview.from | date:'HH:mm' }}–{{ preview.till | date:'HH:mm' }}</span>
                            </div>
                        }
                    </app-data-list>
                    @if (!previewRealisations()?.length) {
                        <span class="results-empty">Geen datums. Controleer de dagen en de einddatum.</span>
                    }
                </div>
                <div class="results-total">
                    <span class="ui-muted">Totaal</span>
                    <span class="ui-mono results-total-value">{{ hoursLabel(previewMinutes()) }}</span>
                    <span class="ui-muted">uur</span>
                </div>
            </app-section>
        </form>

        @if (registrations()?.length > 0) {
            <app-section [flush]="true" icon="clock" layout="stacked" title="Registraties">
                <app-data-list columns="minmax(0,1fr) minmax(0,1fr) minmax(0,1fr) minmax(0,1fr)" minWidth="640px">
                    <div app-data-row header>
                        <span>Startdatum</span>
                        <span>Einddatum</span>
                        <span>Medewerker</span>
                        <span>Goedgekeurd</span>
                    </div>
                    @for (realisation of registrations(); track realisation.id) {
                        <div app-data-row dense>
                            <span>{{ realisation.starttime | date : 'EEE d MMM yyyy HH:mm' }}</span>
                            <span>{{ realisation.endtime | date : 'EEE d MMM yyyy HH:mm' }}</span>
                            <span>{{ (users() | byId : realisation.user_id)?.name }}</span>
                            <span>{{ realisation.approved_at | date : 'EEE d MMM yyyy HH:mm' }}</span>
                        </div>
                    }
                </app-data-list>
            </app-section>
        }
    } @else {
        <app-empty-state>Aan het laden...</app-empty-state>
    }

    @if (form && canSaveLeave) {
        <app-sticky-save-bar (cancel)="backToOverview()"
                             (save)="save()"
                             [dirty]="form.dirty"
                             [saveLabel]="saved ? 'Wijzigingen opgeslagen' : (leave()?.id ? 'Wijzigingen opslaan' : 'Verlof aanvragen')"
                             [saving]="saving"
                             [valid]="form.valid"
                             cancelLabel="Naar overzicht"></app-sticky-save-bar>
    }
</app-page>

